import React from 'react'

import { PanelHeader, PanelBody } from '../../../../components/Panel/Panel'
import { Chartv2 } from './Chartv2'
import style from './HistoryChart.module.css'

export default function HistoryChart({ width, units, ranges, results, result = null, showNewVersion = false, laboratory = '' }) {
  if (!results || !results.length) {
    return null
  }
  return (
    <>
      <PanelHeader style={{ marginTop: 16 }}>
        <h2 className={style.chartTitle}>History</h2>
        <span className={style.chartUnits}>{units}</span>
      </PanelHeader>
      <PanelBody>
        <Chartv2 data={results} ranges={ranges} />
        <span className={style.chartFooter}>
          * The above graph represents testing performed by&nbsp;<strong> {laboratory} </strong>
        </span>
      </PanelBody>
    </>
  )
}
